import type { LoadMode } from "./types.js";

export interface HistoryResultValue {
  weightValue: number | null;
  reps: number | null;
  countValue: number | null;
}

export interface LastPerformanceValue {
  weightValue: number | null;
  reps: number[];
  countValue: number | null;
}

export function formatLastPerformance(
  mode: LoadMode,
  value: LastPerformanceValue,
) {
  if (mode === "count") return `${value.countValue ?? 0} count`;
  const reps = value.reps.length ? value.reps.join(" / ") : "—";
  if (mode === "bodyweight")
    return `${value.weightValue && value.weightValue > 0 ? `Bodyweight + ${value.weightValue} kg` : "Bodyweight"} · ${reps}`;
  return `${value.weightValue ?? "—"} kg · ${reps}`;
}

export function formatExerciseResult(mode: LoadMode, row: HistoryResultValue) {
  if (mode === "count") return `${row.countValue ?? 0} count`;
  if (mode === "bodyweight")
    return `${row.weightValue && row.weightValue > 0 ? `Bodyweight + ${row.weightValue} kg` : "Bodyweight"}${row.reps !== null ? ` · ${row.reps} reps` : ""}`;
  return `${row.weightValue !== null ? `${row.weightValue} kg · ` : ""}${row.reps ?? 0} reps`;
}

export function historyMetricValue(
  metric: "weight" | "count" | "reps",
  row: HistoryResultValue,
) {
  return metric === "count"
    ? (row.countValue ?? 0)
    : metric === "reps"
      ? (row.reps ?? 0)
      : (row.weightValue ?? 0);
}
